import { RuleActionType, TeamRecipientsTypes, SendEmailActionTypes, TicketSkillsActionType } from './rule-actions-type.enum';
import { AssignTicketTypes } from './rule.i';
import { SkillType } from '../..';
var RuleActionBuilder = /** @class */ (function () {
    function RuleActionBuilder() {
        this.action = {
            type: RuleActionType.TICKET_SET_LABELS
        };
    }
    RuleActionBuilder.prototype.withType = function (type) {
        // TODO: remove switch once all types supported
        switch (type) {
            case RuleActionType.TICKET_SET_LABELS:
            case RuleActionType.TICKET_SET_STATUS:
            case RuleActionType.TICKET_ASSIGN:
            case RuleActionType.TICKET_DELETE:
            case RuleActionType.BAN_USER:
            case RuleActionType.TICKET_MARK_SPAM:
            case RuleActionType.TICKET_MARK_HAM:
            case RuleActionType.TICKET_ADD_AGENT_REPLY:
            case RuleActionType.SEND_EMAIL:
            case RuleActionType.TICKET_SET_PRIORITY:
            case RuleActionType.TICKET_SET_BOOLEAN_CUSTOM_FIELD:
            case RuleActionType.TICKET_SET_VALUE_TO_CUSTOM_FIELD:
            case RuleActionType.TICKET_SET_TEXT_CUSTOM_FIELD:
            case RuleActionType.TICKET_SET_NUMBER_CUSTOM_FIELD:
            case RuleActionType.TICKET_SET_SINGLE_SELECT_CUSTOM_FIELD:
            case RuleActionType.TICKET_ADD_RELATED_ARTICLES:
            case RuleActionType.TICKET_SET_LANGUAGE:
            case RuleActionType.TICKET_SET_SLA_POLICY:
            case RuleActionType.TICKET_ADD_CC_USERS:
            case RuleActionType.TICKET_SET_MULTI_LEVEL_CUSTOM_FIELD:
            case RuleActionType.TICKET_SET_BRAND:
            case RuleActionType.TICKET_SET_SKILLS:
            case RuleActionType.TICKET_ADD_AGENT_INTERNAL_REPLY:
                this.action.type = type;
                break;
            default:
                break;
        }
        return this;
    };
    // tslint:disable-next-line:max-line-length
    RuleActionBuilder.prototype.withEmailData = function (subject, content, sendEmailActionType, data) {
        if (data === void 0) { data = []; }
        switch (this.action.type) {
            case RuleActionType.SEND_EMAIL:
                this.action.emailSubject = subject;
                this.action.emailContent = content;
                this.action.sendEmailActionType = sendEmailActionType;
                switch (sendEmailActionType) {
                    case SendEmailActionTypes.AGENTS:
                        this.action.userIds = data;
                        break;
                    case SendEmailActionTypes.GROUPS:
                        this.action.groupIds = data;
                        break;
                    case SendEmailActionTypes.EMAILS:
                        this.action.emails = data;
                        break;
                    case SendEmailActionTypes.TICKET_OWNER:
                        this.action.toTicketOwner = true;
                        break;
                    case SendEmailActionTypes.ALL_AGENTS:
                        this.action.teamRecipientsType = TeamRecipientsTypes.ALL_AGENTS;
                        break;
                    case SendEmailActionTypes.ALL_ADMINS:
                        this.action.teamRecipientsType = TeamRecipientsTypes.ALL_ADMINS;
                        break;
                    case SendEmailActionTypes.ALL:
                        this.action.teamRecipientsType = TeamRecipientsTypes.ALL;
                        break;
                    case SendEmailActionTypes.ACCOUNT_OWNER:
                        this.action.toCompanyAccountManager = true;
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
        return this;
    };
    RuleActionBuilder.prototype.withData = function (data, subAction) {
        switch (this.action.type) {
            case RuleActionType.TICKET_SET_LABELS:
                this.action.labelsActionType = subAction;
                this.action.labelIds = data;
                break;
            case RuleActionType.TICKET_SET_STATUS:
                this.action.status = data;
                break;
            case RuleActionType.TICKET_ASSIGN:
                if (subAction === AssignTicketTypes.USER) {
                    this.action.assignedUserId = data;
                    this.action.assignedGroupId = '';
                }
                else {
                    this.action.assignedUserId = '';
                    this.action.assignedGroupId = data;
                }
                this.action.assignType = subAction;
                break;
            case RuleActionType.TICKET_ADD_AGENT_REPLY:
                this.action.content = data;
                break;
            case RuleActionType.TICKET_SET_PRIORITY:
                this.action.priority = data;
                break;
            case RuleActionType.TICKET_SET_BOOLEAN_CUSTOM_FIELD:
                this.action.value = data;
                break;
            case RuleActionType.TICKET_SET_TEXT_CUSTOM_FIELD:
                this.action.value = data;
                break;
            case RuleActionType.TICKET_SET_NUMBER_CUSTOM_FIELD:
                this.action.value = data;
                break;
            case RuleActionType.TICKET_SET_SINGLE_SELECT_CUSTOM_FIELD:
                this.action.value = data;
                break;
            case RuleActionType.TICKET_ADD_RELATED_ARTICLES:
                this.action.articleIds = data;
                break;
            case RuleActionType.TICKET_SET_LANGUAGE:
                this.action.ticketLocale = data;
                break;
            case RuleActionType.TICKET_SET_SLA_POLICY:
                this.action.policyId = data;
                break;
            case RuleActionType.TICKET_ADD_CC_USERS:
                if (data.toCompanyAccountManager) {
                    var obj = data;
                    this.action.toCompanyAccountManager = obj.toCompanyAccountManager;
                    this.action.ccRecipients = obj.ccRecipients;
                }
                else {
                    this.action.ccRecipients = data;
                }
                break;
            case RuleActionType.TICKET_SET_BRAND:
                this.action.brandId = data;
                break;
            case RuleActionType.TICKET_SET_SKILLS:
                this.action.skillIds = data;
                this.action.skillsActionType = TicketSkillsActionType.REPLACE;
                this.action.skillType = SkillType.PRODUCT_SKILL;
                break;
            case RuleActionType.TICKET_ADD_AGENT_INTERNAL_REPLY:
                this.action.content = data;
                break;
            default:
                break;
        }
        return this;
    };
    RuleActionBuilder.prototype.withCustomFieldAction = function (customFieldAction) {
        switch (this.action.type) {
            case RuleActionType.TICKET_SET_VALUE_TO_CUSTOM_FIELD:
                this.action.action = customFieldAction;
                return this;
        }
        return this;
    };
    RuleActionBuilder.prototype.withName = function (name) {
        switch (this.action.type) {
            case RuleActionType.TICKET_SET_BOOLEAN_CUSTOM_FIELD:
            case RuleActionType.TICKET_SET_TEXT_CUSTOM_FIELD:
            case RuleActionType.TICKET_SET_NUMBER_CUSTOM_FIELD:
            case RuleActionType.TICKET_SET_SINGLE_SELECT_CUSTOM_FIELD:
                this.action.name = name;
                break;
            default:
                return this;
        }
        return this;
    };
    RuleActionBuilder.prototype.build = function () {
        return this.action;
    };
    return RuleActionBuilder;
}());
export { RuleActionBuilder };
//# sourceMappingURL=rule-action.builder.js.map